module.exports = __webpack_public_path__ + "img/title_3.8fa23067.png";